import React, { useState } from 'react';
import { useRef } from 'react';
import { IDevice } from '../../interfaces';
import { geocode, getShopsIntersectingWithPoints } from '../../utils/pricing';
import { MapWrapper } from './MapView';

export interface IEntry {
    address: string;
    lng: number;
    lat: number;
}

const Editor = (props: { next: (addresses: string[]) => void }) => {
    const [state, setState] = useState({
        contents: ''
    });

    return (
        <div>
            <h6>Entrez les adresses que vous souhaitez mapper. (1 par ligne)</h6>
            <textarea
                className="form-control"
                onChange={(e) => setState({ ...state, contents: e.target.value })}
                value={state.contents}
                rows={30}
                autoComplete="off"
                autoCorrect="off"
                placeholder="ex: 267 Boulevard Pereire 75017 PARIS"
            ></textarea>
            <button className="btn btn-info mt-10" onClick={() => props.next(state.contents.split('\n'))}>
                Calculer
            </button>
        </div>
    );
};

const Recap = (props: {
    devices: IDevice[];
    entries: IEntry[];
    addresses: string[];
    index: number;
    radius: number;
    onCompute: (radius: number) => void;
    onAdd: () => void;
}) => {
    const input = useRef<HTMLInputElement | null>(null);

    return (
        <div className="recap-pois">
            <h6>Ecrans</h6>
            <div className="flex-conflicts-col">
                <table className="table">
                    <thead>
                        <tr>
                            <th>Adresse</th>
                            <th>Longitude</th>
                            <th>Latitude</th>
                            <th>State</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.entries.map((e, i) => (
                            <tr key={i}>
                                <td>{e.address}</td>
                                <td>{e.lng}</td>
                                <td>{e.lat}</td>
                                <td>{e.lat === 0 ? '❌' : '✅'}</td>
                            </tr>
                        ))}
                        {props.addresses.slice(props.index).map((a) => (
                            <tr key={a}>
                                <td>{a}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className="map-conflicts-pois">
                    <MapWrapper devices={props.devices} zones={props.entries} radius={props.radius} />
                    <div className="form-group">
                        <label>Radius:</label>
                        <input type="number" ref={input} defaultValue="100" className="form-control" />
                        <button
                            className="btn btn-info"
                            onClick={() => props.onCompute(input.current ? parseInt(input.current.value) : 100)}
                            disabled={props.index < props.addresses.length}
                        >
                            Calculer
                        </button>
                    </div>
                    <button
                        onClick={props.onAdd}
                        className="btn btn-info"
                        style={{ width: 'fit-content', marginLeft: 'auto' }}
                    >
                        Ajouter
                    </button>
                </div>
            </div>
        </div>
    );
};

export const PoiManager = (props: {
    close: () => void;
    allDevices: IDevice[];
    onAddDevices: (devices: IDevice[]) => void;
}) => {
    const [state, setState] = useState<{
        closing: boolean;
        editing: boolean;
        addresses: string[];
        entries: IEntry[];
        cursor: number;
        radius: number;
        devices: IDevice[];
    }>({
        closing: false,
        editing: true,
        addresses: [],
        entries: [],
        cursor: 0,
        radius: 100,
        devices: []
    });

    let component = null;

    if (state.editing) {
        component = (
            <Editor
                next={async (addresses) => {
                    setState((prevState) => ({ ...prevState, editing: false, addresses }));

                    for (const address of addresses) {
                        const data = await geocode(address);
                        setState((prevState) => ({
                            ...prevState,
                            cursor: prevState.cursor + 1,
                            entries: [...prevState.entries, data]
                        }));
                    }
                }}
            />
        );
    } else {
        component = (
            <Recap
                addresses={state.addresses}
                entries={state.entries}
                devices={state.devices}
                index={state.cursor}
                radius={state.radius}
                onAdd={() => props.onAddDevices(state.devices)}
                onCompute={(radius) => {
                    const devices = getShopsIntersectingWithPoints(props.allDevices, state.entries, radius);

                    setState({ ...state, radius, devices });
                }}
            />
        );
    }

    return (
        <div className={`modal-background${state.closing ? ' closing' : ''}`}>
            <div
                className="closeBtn"
                onClick={() => {
                    setState({
                        ...state,
                        closing: true
                    });

                    setTimeout(props.close, 200);
                }}
            >
                ✕
            </div>
            <div className="modal">{component}</div>
        </div>
    );
};
